import { render, staticRenderFns } from "./gtin-component.vue?vue&type=template&id=724e2bb0&scoped=true"
import script from "./gtin-component.vue?vue&type=script&lang=js"
export * from "./gtin-component.vue?vue&type=script&lang=js"
import style0 from "./gtin-component.vue?vue&type=style&index=0&id=724e2bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724e2bb0",
  null
  
)

export default component.exports